import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6113b3f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-container"
};
const _hoisted_2 = {
  class: "add-tenant"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 2
};
const _hoisted_6 = {
  key: 3
};
const _hoisted_7 = {
  class: "pagination-box"
};
import { delEnterprise, getEnterpriseByTenantId } from '@/api/tenant';
import { ElMessage, ElMessageBox } from 'element-plus';
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import wxInfo from './components/WxInfo';
import addWxUser from '@/components/WxChatUser';
// import { getUserByTenantIdAndClinicId } from '@/api/user'
import { indexMethod } from '@/utils/indexMethod';
import { arrayToTree } from '@/utils/arrayToTree';
import applinkManager from './components/Applink';
import { tableDataSchemas } from './config';
import SubTenant from './components/SubTenant';
import WjCOnfig from './components/WjCOnfig.vue';
import { asyncClinicDomain } from '@/api/clinic';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const parentId = computed(() => {
      return route.params.tenantId || '';
    });
    // 数据相关
    const allTenantData = ref([]);
    const total = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(20);
    const loading = ref(false);
    const headquartersFromOptions = ref([]);
    const getAllTenant = async () => {
      loading.value = true;
      const res = await getEnterpriseByTenantId({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        tenantId: parentId.value
      });
      headquartersFromOptions.value = res.records.filter(item => {
        return item.isParent === 1;
      });
      console.log();
      if (res.records.length > 1) {
        allTenantData.value = arrayToTree(res.records, 'id', 'parentId', 'children', null);
      } else {
        allTenantData.value = res.records;
      }
      total.value = res.total;
      loading.value = false;
    };
    onMounted(() => {
      getAllTenant();
    });
    const handleCurrentChange = val => {
      currentPage.value = val;
      getAllTenant();
    };
    const dialogTenantVisible = ref(false);
    const type = ref('password');
    const addTenantHandler = () => {
      type.value = 'add';
      dialogTenantVisible.value = true;
    };
    const delTenantHandler = async row => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
        await delEnterprise(row.id);
        await getAllTenant();
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {
        console.log(`error: ${error}`);
      }
    };
    const current = ref(null);
    const editTenantHandler = async row => {
      type.value = 'update';
      current.value = row;
      dialogTenantVisible.value = true;
    };

    // const updatePasswordHandler = async (row) => {
    //   type.value = 'password'
    //   current.value = row
    //   dialogTenantVisible.value = true
    // }

    const isVisible = ref(false);
    const currentClinicId = ref('');
    const onShowWxMsgHandler = row => {
      isVisible.value = true;
      currentClinicId.value = row.clinicId;
    };

    // 添加微信聊天用户
    const isAddWxUserShow = ref(false); // show or hide

    const currentTenantId = ref(0); // 当前租户id

    const currentWxClinicId = ref(''); // 当前诊所id

    const currentWxUser = ref(null);
    const clearModel = () => {
      currentTenantId.value = 0;
      currentWxClinicId.value = '';
      currentWxUser.value = null;
    };

    // const addWxChatUser = async (row) => {
    //   currentTenantId.value = row.id
    //   currentWxClinicId.value = row.clinicId
    //   if (!currentTenantId.value) {
    //     ElMessage.warning({
    //       message: '当前租户无租户id'
    //     })
    //     return
    //   }
    //   if (!currentWxClinicId.value) {
    //     ElMessage.warning({
    //       message: '当前租户无id'
    //     })
    //     return
    //   }
    //   const res = await getUserByTenantIdAndClinicId(row.clinicId)
    //   if (res.data) {
    //     currentWxUser.value = res.data
    //   }
    //   isAddWxUserShow.value = true
    // }

    const applinkManagerVisible = ref(false);
    const currentAppLinkData = ref({});
    const appLinkManagerHandler = row => {
      currentAppLinkData.value = row;
      applinkManagerVisible.value = true;
    };
    const closeAppLinkManager = () => {
      applinkManagerVisible.value = false;
    };

    // const router = useRouter()
    // const handleClinicUser = (row) => {
    //   router.push(`/clinic/user/${row.id}?tenantId=${parentId.value}`)
    // }

    async function handleAsyncClinicDomain(row) {
      await asyncClinicDomain(row.id);
      ElMessage({
        message: '操作成功',
        type: 'success'
      });
    }
    const wjConfigVisible = ref(false);
    const wjCOnfigTarget = ref(null);
    async function handleWjConfigSaveOrUd(row) {
      wjCOnfigTarget.value.saveOrUd(row.tenantId, row.clinicId);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: addTenantHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: allTenantData.value,
          style: {
            "width": "100%"
          },
          "row-key": "id",
          "tree-props": {
            children: 'children',
            hasChildren: 'hasChildren'
          },
          "default-expand-all": "",
          "highlight-current-row": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "80",
            index: index => _unref(indexMethod)(index, currentPage.value, pageSize.value),
            style: {
              "background-color": "red !important"
            },
            align: "center"
          }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), item => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: item.prop,
              label: item.label,
              "min-width": item.minWidth,
              align: "center"
            }, {
              default: _withCtx(({
                row
              }) => [item.prop === 'name' ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createTextVNode(_toDisplayString(row[item.prop]) + " ", 1), row.fsTenantId ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                className: "icon-class",
                icon: "new-lark"
              })) : _createCommentVNode("", true), row.accountId ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 1,
                className: "icon-class",
                icon: "wechat"
              })) : _createCommentVNode("", true), row.smsId ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 2,
                className: "icon-class",
                icon: "messages"
              })) : _createCommentVNode("", true)])) : item.prop === 'createTime' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row[item.prop]), 1)) : item.prop === 'expireDate' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$filters.dateFilter(row[item.prop])), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row[item.prop]), 1))]),
              _: 2
            }, 1032, ["label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            "min-width": "480",
            align: "center"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => editTenantHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => delTenantHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "success",
              size: "small",
              onClick: $event => onShowWxMsgHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 微信信息显示 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => appLinkManagerHandler(row),
              color: "purple"
            }, {
              default: _withCtx(() => [_createTextVNode(" appLink管理 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "",
              size: "small",
              onClick: $event => handleAsyncClinicDomain(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 同步诊所域 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => handleWjConfigSaveOrUd(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 配置卫监 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), isAddWxUserShow.value ? (_openBlock(), _createBlock(_unref(addWxUser), {
        key: 0,
        modelValue: isAddWxUserShow.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isAddWxUserShow.value = $event),
        tenantId: currentTenantId.value,
        clinicId: currentWxClinicId.value,
        onClearModel: clearModel,
        model: currentWxUser.value
      }, null, 8, ["modelValue", "tenantId", "clinicId", "model"])) : _createCommentVNode("", true), _createVNode(_unref(wxInfo), {
        clinicId: currentClinicId.value,
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isVisible.value = $event)
      }, null, 8, ["clinicId", "modelValue"]), _createVNode(_unref(SubTenant), {
        headquartersFromOptions: headquartersFromOptions.value,
        modelValue: dialogTenantVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogTenantVisible.value = $event),
        parentId: parentId.value,
        model: current.value,
        type: type.value,
        onData: getAllTenant,
        onClearModel: _cache[3] || (_cache[3] = $event => current.value = null)
      }, null, 8, ["headquartersFromOptions", "modelValue", "parentId", "model", "type"]), _createVNode(_unref(applinkManager), {
        modelValue: applinkManagerVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => applinkManagerVisible.value = $event),
        onClose: closeAppLinkManager,
        data: currentAppLinkData.value,
        onGetData: getAllTenant
      }, null, 8, ["modelValue", "data"]), _createVNode(WjCOnfig, {
        ref_key: "wjCOnfigTarget",
        ref: wjCOnfigTarget,
        modelValue: wjConfigVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => wjConfigVisible.value = $event)
      }, null, 8, ["modelValue"])]);
    };
  }
};